import { render, staticRenderFns } from "./KickOutIgnoreList.vue?vue&type=template&id=a4df79f2&"
import script from "./KickOutIgnoreList.vue?vue&type=script&lang=js&"
export * from "./KickOutIgnoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports